export default __webpack_public_path__ + "3ab04caa1c3a870c54c2f57c6e2fd91d.png";